import { Input } from 'antd';
import styled from 'styled-components';

export const SearchInput = styled(Input.Search)`
  width: 100%;

  @media (min-width: ${({ theme }) => theme.mediaQueries.xs}) {
    width: 320px;
  }
`;
